module.exports = __webpack_public_path__ + "static/media/phone_8.66dc1df7.png";